module.exports = __webpack_public_path__ + "static/media/bacon.82b93a90.svg";